<div [formGroup]="form" class="row m-0 p-0 justify-content-between gap-2 position-relative m-0 p-0">
	@if(type() == "number"){
		@for(name of controlNames; track name){
			<input #input [formControlName]="name" autocomplete="off" pattern="\d*" inputmode="numeric" maxlength="1" minlength="1" placeholder="#" class="col form-control control-input">
		}
	}
	@else {
		@for(name of controlNames; track name){
			<input #input [formControlName]="name" autocomplete="off" maxlength="1" minlength="1" placeholder="#" class="col form-control control-input">
		}
	}
</div>

<app-form-validation [control]="control()"/>